// Mixpanel session replay: elements with this class are exempt from masking (matched by
// record_unmask_text_selector in the Mixpanel init config). Only apply to non-PII content.
export const SESSION_REPLAY_UNMASK_CLASS = "mp-unmask";
